export const OVERVIEW_TABS = [
  { label: 'Summary', value: 'summary' },
  { label: 'Play by Play', value: 'play-by-play' },
];
